export default "__VITE_ASSET__CvQFVBN$__"